export default function getSystemInfo () {
  const {clientWidth, clientHeight} = document.body;
  
  // 可用尺寸
  const availableSizes : any = {
    height: clientHeight - getNavigation() * 4,
    width: clientWidth,
    defaultHeight: clientHeight - getNavigation()
  }
  
  let footer : any = {
    height: Math.floor(getNavigation() / 44 * 60),
    width: 0
  }
  
  
  const proportion = 16 / 9;
  const narrow = 0.9
  const screenProportion = availableSizes.height / availableSizes.width
  const deviceSize: any = screenProportion >= proportion ?
    {width: availableSizes.width * narrow, height: Math.floor(availableSizes.width * proportion) * narrow} :
    {width: Math.floor(availableSizes.height / proportion) * narrow, height: availableSizes.height * narrow}
  footer.width = deviceSize.width
  //window.localStorage.setItem('SystemInfo',  JSON.stringify({availableSizes, deviceSize, footer}))
  return {availableSizes, deviceSize, footer}
}


export function getNavigation () {
  const {clientWidth, clientHeight} = document.body;
  return Math.floor( 40 * 375 / clientWidth )
  
}